import { NavLink } from "react-router-dom";
import TaLogo from "../components/TaLogo";
import "../../style/components/Footer.scss";

const termsFileLink = "/asset/download/Topassist-Voorwaarden.pdf";

export default function Footer(_) {
  const scrollToTop = () => window.scroll({ top: 0, behavior: "smooth" });

  return (
    <footer>
      <div className="left">
        <div className="links">
          <NavLink to="/" onClick={scrollToTop}>
            <TaLogo className="ta-logo" />
          </NavLink>
          <a href={termsFileLink} download>
            Algemene voorwaarden
          </a>
        </div>
      </div>
      <div className="center">
        <div>
          <span>Argon 15o, 4751 XC</span>
          <span>Oud Gastel</span>
        </div>
        <div>
          <a href="tel:0165 745 295">0165-745295</a>
          <a href="mailto:info@topassist.nl">info@topassist.nl</a>
        </div>
        <div>
          <span>Maandag t/m vrijdag</span>
          <span>08:30 - 17:00 uur</span>
        </div>
        <a className="mobile-el" href={termsFileLink} download>
          Algemene voorwaarden
        </a>
      </div>
      <div className="mobile-right">
        <a href="https://ictwaarborg.nl/" target="_blank" rel="noreferrer">
          <img
            src="/asset/partner/ict-waarborg_720.webp"
            alt="ICT-waarborg logo"
          ></img>
        </a>
        <a href="https://www.nldigital.nl/" target="_blank" rel="noreferrer">
          <img src="/asset/partner/nl-digital.svg" alt="NL-digital logo"></img>
        </a>
      </div>
      <div className="right">
        <div className="support-downloads">
          <span>Support op afstand</span>
          <div className="buttons">
            <a href="https://download.splashtop.com/sos/SplashtopSOS.exe">Windows</a>
            <hr />
            <a href="https://download.splashtop.com/sos/SplashtopSOS.dmg">MacOS</a>
          </div>
        </div>
        <div className="logos">
          <a href="https://ictwaarborg.nl/" target="_blank" rel="noreferrer">
            <img
              src="/asset/partner/ict-waarborg_720.webp"
              alt="ICT-waarborg logo"
            ></img>
          </a>
          <a href="https://www.nldigital.nl/" target="_blank" rel="noreferrer">
            <img
              src="/asset/partner/nl-digital.svg"
              alt="NL-digital logo"
            ></img>
          </a>
        </div>
      </div>
    </footer>
  );
}
